module.exports = __webpack_public_path__ + "img/avatar2.7e4e1af8.png";